import * as yup from "yup";

import { messagesConstants } from "@/constants";

export const updateEventShareDetailsFormShareDetailsUpdateEventFormSchema = yup.object({
    emailBottomBodyText: yup.string(),
    emailCallToAction: yup.string().required(messagesConstants.inputsMsgs.action),
    emailFromName: yup.string().required(messagesConstants.inputsMsgs.name),
    emailSubject: yup.string().required(messagesConstants.inputsMsgs.subject),
    emailTopBodyText: yup.string().required(messagesConstants.inputsMsgs.text),
    smsText: yup.string().required(messagesConstants.inputsMsgs.text),
});
